import { graphql, HttpResponse } from 'msw'
import { type EnrollmentHYCSDisclosuresData, type EnrollmentHYCSDisclosuresSubmitOutput } from '../../../../models'

export const getEnrollmentHYCSDisclosuresDataMock: EnrollmentHYCSDisclosuresData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/disclosures',
}

export const submitEnrollmentHYCSDisclosuresDataMock: EnrollmentHYCSDisclosuresSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/setting-up',
}

export const mockGetEnrollmentHYCSDisclosuresData = graphql.mutation('getEnrollmentHYCSDisclosuresData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentHYCSDisclosuresDataMock } })
})

export const mockSubmitEnrollmentHYCSDisclosuresData = graphql.mutation('submitEnrollmentHYCSDisclosuresData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentHYCSDisclosuresDataMock } })
})

export const mockEnrollmentHYCSDisclosures = [
  mockGetEnrollmentHYCSDisclosuresData,
  mockSubmitEnrollmentHYCSDisclosuresData,
]
